import { render, staticRenderFns } from "./withdrawalHistoryMobile.vue?vue&type=template&id=78ecbef0"
import script from "./withdrawalHistoryMobile.vue?vue&type=script&lang=js"
export * from "./withdrawalHistoryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports